
<template>
  <el-form-item :label="params.label">
    <el-date-picker
      class="w130"
      size="small"
      v-model="value"
      placeholder="选择日期">
    </el-date-picker>
  </el-form-item>
</template>

<script>
import { dateFormat } from '@/utils/tools'
export default {
  name: 'form-data',
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      value: this.params.value ? new Date(this.params.value) : null
    }
  },
  created() {
  },
  methods: {
    reset() {
      if (this.params.dValue) {
        this.value = this.params.dValue
      } else {
        this.value = undefined
      }
    },
    getValue() {
      if (this.value) {
        if (this.params.from === 'end') {
          return {
            [this.params.key]: dateFormat(this.value, 'yyyy-MM-dd 23:59:59')
          }
        } else {
          return {
            [this.params.key]: dateFormat(this.value, 'yyyy-MM-dd 00:00:00')
          }
        }
      }
      return undefined
    }
  },
  watch: {
    value(nv, ov) {
      const cp = JSON.parse(JSON.stringify(this.params))
      cp.value = dateFormat(nv, 'yyyy-MM-dd')
      this.$emit('csi', cp)
    }
  }
}
</script>

<style lang="less">
@import "../miBicycle.less";
</style>
